export const hasTutorAssigned = ({ context }) => !!context.tutorId;
export const hasValidTimeSlot = ({ context }) => !!context.startDateTime && !!context.endDateTime;
export const isWithinCancellationWindow = ({ context }) => {
    if (!context.startDateTime)
        return false;
    const hoursUntilStart = (new Date(context.startDateTime).getTime() - Date.now()) / (1000 * 60 * 60);
    return hoursUntilStart > 24; // 24-hour cancellation policy
};
//# sourceMappingURL=tutoring-session.js.map